var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-window-manager" },
    [
      _vm.multiChatView.enabled
        ? _c("MultiChatViewer", { on: { close: _vm.closeMultiChatView } })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeView === _vm.VIEWS.CHAT
        ? _c("GridChatWindowManager", {
            ref: "gridWindow",
            attrs: {
              contacts: _vm.chatContacts,
              contact: _vm.selectedContact,
              loading: _vm.loading,
            },
            on: { loadMoreContacts: _vm.loadMoreContacts },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeView === _vm.VIEWS.FILTER
        ? _c("FilterPanel", { attrs: { filterId: _vm.filterId } })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeView === _vm.VIEWS.LIST
        ? _c("TableContactList", { attrs: { filterId: _vm.filterId } })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeView === _vm.VIEWS.KANBAN
        ? _c("KanbanContactList", { attrs: { filterId: _vm.filterId } })
        : _vm._e(),
      _vm._v(" "),
      _vm.activeView === _vm.VIEWS.TAB
        ? _c("ContactSwitchScreen", {
            on: {
              close: function () {
                return _vm.setActiveView(_vm.VIEWS.CHAT)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.disabledTools.includes(_vm.activeView) && !_vm.multiChatView.enabled
        ? _c("ChatWindowManagerTool")
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }